import ApiService from "@/service/api";

export const DataService = {

    getApiToken() {
        return ApiService.get("/external/api_token");
    },

    getCurrentSubscription() {
        return ApiService.get("/external/current_subscriptions");
    },

    getCurrentResidentialSubscription() {
        return ApiService.get("/external/residential/current_subscription");
    },

    getCurrentDatacenterSubscription() {
        return ApiService.get("/external/datacenter/current_subscription");
    },

    getUsageGraph(startDateString, endDateString) {
        return ApiService.get(`/external/usage_graph?from_date=${startDateString}&to_date=${endDateString}`);
    },

    getResidentialUsageGraph(startDateString, endDateString) {
        return ApiService.get(`/external/residential/usage_graph?from_date=${startDateString}&to_date=${endDateString}`);
    },

    getDatacenterUsageGraph(startDateString, endDateString) {
        return ApiService.get(`/external/datacenter/usage_graph?from_date=${startDateString}&to_date=${endDateString}`);
    },

    generateNewApiToken() {
        return ApiService.post("/external/api_token");
    },

    getPlans() {
        return ApiService.get("/external/plans");
    },

    async getResidentialPlans() {
        try {
            const response = await ApiService.get("/external/residential/plans");
            return response;
        } catch (error) {
            return {
                data: []
            };
        }
    },

    async getDatacenterPlans() {
        try {
            const response = await ApiService.get("/external/datacenter/plans");
            return response;
        } catch (error) {
            return {
                data: []
            };
        }
    },

    sendFeedback(data) {
        return ApiService.post("/external/request_feedback", data)
    },

    async getAPIRenewStatus() {
        try {
            return await ApiService.get("/external/webscrapingapi/auto_prolong_state");
        } catch (error) {
            return {
                data: {
                    auto_prolong_web_scraping_api: false
                }
            };
        }
    },

    async setAPIRenewStatus(data) {
        return ApiService.post("/external/webscrapingapi/auto_prolong_state", data);
    }
};
